<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-7.jpg)' }"
  class="content-header"
>
  <h2 class="header-title">Master Action</h2>
  <h3 class="header-subtitle">Incident Table</h3>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div class="random-actions">
  <app-dropdown
    *ngIf="isAdmin"
    [(choice)]="selectedBase"
    label="Base"
    [options]="bases"
    key="displayValue"
    (selectedDropdownItem)="selectBase($event)"
  ></app-dropdown>
  <app-dropdown
    [(choice)]="selectedYear"
    label="Year"
    [(options)]="years"
    key="name"
    (selectedDropdownItem)="selectYear($event)"
  ></app-dropdown>
</div>
<app-table
  class="incidents-table"
  hasActions="true"
  [settings]="settings"
  [rows]="incidents"
  [columns]="headings"
  (deleted)="confirmDeleteIncident($event)"
  [tableCellTemplate]="cellTemplate"
>
  <ng-template #cellTemplate let-cell="cell">
    <div class="cell">
      <span>{{ cell.value }}</span>
    </div>
  </ng-template>
</app-table>
